import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from '@mui/material';
import { Close } from '@mui/icons-material';
import useModalGridDashboardExibirProdutosHook from './useModalGridDashboardExibirProdutosHook';
import LoaderMain from '../../../Onboarding/shared/LoaderMain';

const ModalGridDashboardExibirProdutos = ({
  ModalGridExibirProdutos,
  setModalGridExibirProdutos,
  dadosUser,
  setAlerta
}) => {
  const {
    productArray,
    limitesVencidos,
    produtosConjunto,
    formatarListaProdutos,
    limiteRiscoDisponivel,
    columnConfigs,
    isLoading
  } = useModalGridDashboardExibirProdutosHook({
    ModalGridExibirProdutos,
    setModalGridExibirProdutos,
    dadosUser,
    setAlerta
  });

  if (!ModalGridExibirProdutos) return null;

  return (
    <Dialog
      open
      fullWidth
      maxWidth="lg"
      keepMounted
      onClose={() => setModalGridExibirProdutos(false)}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 'bold' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '2px solid #ccc',
            pb: 1
          }}
        >
          <Typography variant="h6" className="azul-one7-cor">
            Produtos Ativos
          </Typography>
          <IconButton onClick={() => setModalGridExibirProdutos(false)}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
            <LoaderMain tipoLoader="bloco" tipoImagem="circulo" />
          </Box>
        ) : (
          <>
            <TableContainer className="tableExibirProdutos texto-cor-cinza-escuro">
              <Table>
                <TableHead className="azul-claro-background">
                  <TableRow>
                    <TableCell className="font-bold">Produto</TableCell>
                    {columnConfigs(dadosUser).map(col => (
                      <TableCell key={col.key} className="font-bold" align="center">
                        {col.nomeColuna}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productArray.map(produto => (
                    <TableRow key={produto.id}>
                      <TableCell>{produto.nomeProduto}</TableCell>
                      {columnConfigs(dadosUser).map((col, idx) => (
                        <TableCell
                          key={col.key}
                          align="center"
                          className={idx % 2 === 0 ? 'striped-vertical-even' : 'striped-vertical-odd'}
                        >
                          {limiteRiscoDisponivel(col.accessor(produto), produto, col.key)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {(limitesVencidos.length > 0 || produtosConjunto.length > 0) && (
              <Box
                sx={{ mt: 3 }}
                className="azul-claro-background alertasProduto texto-cor-cinza-escuro"
              >
                {produtosConjunto.length > 0 && (
                  <Typography variant="body2" className="margin-topbot-10">
                    <span className="font-bold">Limites conjunto </span>
                    <span>para os produtos </span>
                    {formatarListaProdutos(produtosConjunto)}
                  </Typography>
                )}
                {limitesVencidos.map(limite => (
                  <Typography key={limite.id} variant="body2" className="margin-topbot-10">
                    <span className="font-bold">{`Limite ${limite.nomeProduto} `}</span>
                    {limite.msg}
                  </Typography>
                ))}
              </Box>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalGridDashboardExibirProdutos;
